import {Component, inject, OnInit} from '@angular/core';
import {UsuarioService} from '../shared/service/usuario.service';
import {MatDialog} from '@angular/material/dialog';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {UsuarioResumo} from '../shared/model/usuario/usuario-resumo-model';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthService} from '../shared/service/auth.service';
import {CelularMaskPipe} from '../shared/pipe/celular-mask.pipe';
import {DatePipe} from '@angular/common';
import {
  ModalCadastroVisualizacaoUsuarioComponent
} from './modal-cadastro-visualizacao-usuario/modal-cadastro-visualizacao-usuario.component';
import {ModalFiltroUsuarioComponent} from './modal-filtro-usuario/modal-filtro-usuario.component';
import {MsgService} from '../shared/service/msg.service';
import {MatTooltip} from '@angular/material/tooltip';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import { TabelaSkeletonComponent } from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import { PaginatorComponent } from '../shared/components/paginator/paginator.component';
import { PageEvent } from '@angular/material/paginator';
import { FiltrosUsuarioModel } from '../shared/model/usuario/filtros-usuario.model';
import { IdNome } from '../shared/model/id-nome.model';
import { debounceTime, Subject } from 'rxjs';
import { Ambiente } from '../shared/enum/ambiente.enum';

@Component({
  selector: 'app-usuario',
  standalone: true,
  imports: [
    TituloRotinaComponent,
    MatTableModule,
    FormFieldComponent,
    ButtonPadraoComponent,
    CelularMaskPipe,
    DatePipe,
    MatTooltip,
    TabelaSkeletonComponent,
    PaginatorComponent,
  ],
  templateUrl: './usuario.component.html',
  styleUrl: './usuario.component.css'
})
export class UsuarioComponent implements OnInit {
  usuarios: UsuarioResumo[] = [];

  dataSource = new MatTableDataSource<UsuarioResumo>();
  carregandoUsuarios = false;

  displayedColumns: string[] = ['acao', 'foto', 'nome', 'telefone', 'email', 'perfil', 'setor', 'usuarioCriacao', 'dataCriacao', 'usuAlteracao', 'dataAlteracao', 'ativo'];

  page: number = 0;
  limit: number = 15;
  length: number = 0;
  pageSizeOptions = [15, 25, 50, 100]

  readonly statusAtivoDefault: IdNome = { id: 1, nome: 'Ativo' };

  filtroUsuarios: FiltrosUsuarioModel = new FiltrosUsuarioModel();
  filtroModal: { setor?: IdNome, perfil?: IdNome, status?: IdNome } = { status: this.statusAtivoDefault };
  searchSubject = new Subject<string>();

  isHml: boolean = environment.ambiente != Ambiente.PROD;

  private readonly usuarioService = inject(UsuarioService);
  private readonly authService = inject(AuthService);
  private readonly dialog = inject(MatDialog);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly msgService = inject(MsgService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.configurarDebounce();
    this.buscarUsuarios();
  }

  buscarUsuarios() {
    this.carregandoUsuarios = true;
    this.usuarioService.buscarUsuariosResumoPaginado(this.filtroUsuarios, this.page, this.limit).subscribe({
      next: res => {
        this.usuarios = res.content;
        this.dataSource = new MatTableDataSource(this.usuarios);
        this.length = res.totalElements;
      },
      error: () => this.carregandoUsuarios = false,
      complete: () => this.carregandoUsuarios = false
    });
  }

  handlePageEvent(e: PageEvent) {
    this.page = e.pageIndex;
    this.limit = e.pageSize;

    this.buscarUsuarios();
  }

  filtrarUsuarios(valor: string) {
    this.searchSubject.next(valor);
  }

  configurarDebounce(): void {
    this.searchSubject
      .pipe(debounceTime(300))
      .subscribe(valor => {
        this.filtroUsuarios.nome = valor;
        this.zerarPaginacao();
      });
  }

  abrirModalFiltro() {
    this.dialog.open(ModalFiltroUsuarioComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { filtro: this.filtroModal },
      panelClass: 'slide-modal'
    }).afterClosed().subscribe({
      next: res => {
        if (res) {
          this.filtroModal = res;
          this.filtroUsuarios.setorId = res.setor?.id;
          this.filtroUsuarios.perfilId = res.perfil?.id;
          this.filtroUsuarios.ativo = res.status?.id === -1 ? undefined : res.status?.id === 1;
          this.zerarPaginacao();
        }
      }
    });
  }

  limparFiltros() {
    this.filtroModal = { status: this.statusAtivoDefault };
    this.filtroUsuarios.setorId = undefined;
    this.filtroUsuarios.perfilId = undefined;
    this.filtroUsuarios.ativo = true;
    this.zerarPaginacao();
  }

  zerarPaginacao() {
    this.page = 0;
    this.buscarUsuarios();
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

  abrirModal(visualizar: boolean, usuario?: UsuarioResumo) {
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoUsuarioComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, usuarioId: usuario?.id },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        if (dialogRef.componentInstance.salvando) { return; }
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) { dialogRef.close(); }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) { this.buscarUsuarios(); }
      }
    });
  }
}
